import styled from 'styled-components'
import { WebPBackgroundImage } from '@pcln/content-tile'

const ResponsiveWebPImage = styled(WebPBackgroundImage)`
  visibility: hidden;
  @media only screen and (min-width: 768px) {
    visibility: visible;
    background-color: transparent;
    background-size: ${props => props.imageSize};
    flex: 1;
  }
`

ResponsiveWebPImage.displayName = 'ResponsiveWebPImage'

export default ResponsiveWebPImage
